










import { Vue, Component, Prop } from 'vue-property-decorator';

import CustomerImportInSuccess from '@/componentsV2/templates/CustomerImportSuccess/CustomerImportSuccess.vue';
import { ICustomerImportStatus } from '@/models/customer-import';

@Component({
  components: {
    CustomerImportInSuccess
  }
})
export default class CustomerImportSuccess extends Vue {
  @Prop() customerImportData!: ICustomerImportStatus;
  @Prop() stepProps!: any;

  handleCompleted(customerImportStatus: ICustomerImportStatus) {
    this.$emit('empty-state-event', {
      type: 'goToCampaignCreation',
      data: customerImportStatus
    });
  }
}
